import ajax from 'src/commons/ajax';
import {
    getLoginUser,
    isLoginPage,
} from '@ra-lib/admin';
import {formatMenus} from 'src/commons';

/**
 * 获取菜单
 * @returns {Promise<*[]|*>}
 */
async function getMenuData() {
    // 登录页面，不加载
    if (isLoginPage()) return [];

    // 获取服务端数据，并做缓存，防止多次调用接口
    // return getMenuData.__CACHE = getMenuData.__CACHE
    //     || ajax.get('/authority/queryUserMenus', {userId: getLoginUser()?.id})
    //         .then(res => res.map(item => ({...item, order: item.order ?? item.ord ?? item.sort})));

    // 前端硬编码菜单
    return [
        {id: 'profile', title: '画像', path: '/front', order: 900, type: 1},
        {id: 'report', title: '画像', path: '/front/profile', order: 900, type: 1},
        {id: 'rank', title: '排行榜', path: '/front/rank', order: 900, type: 1},
        {id: 'rank-achi', title: '绩效榜', path: '/front/rank-achi', order: 900, type: 1},
        {id: 'pm', title: '流程挖掘', path: '/front/pm', order: 900, type: 1},
        {id: 'wf', title: '工作档案', path: '/front/work-file', order: 900, type: 1},
        {id: 'cockpit', title: '驾驶舱', path: '/front/cockpit', order: 900, type: 1},
        {id: 'idss', title: '智能决策', path: '/front/idss', order: 900, type: 1},
    ];
}

/**
 * 获取系统菜单
 * @returns {Promise<T[]>}
 */
export async function getMenus() {
    const serverMenus = await getMenuData();
    const menus = serverMenus.filter(item => !item.type || item.type === 1);

    return formatMenus(menus);
}

/**
 * 获取用户收藏菜单
 * @returns {Promise<*>}
 */
export async function getCollectedMenus() {
    // 登录页面，不加载
    if (isLoginPage()) return [];

    const loginUser = getLoginUser();
    const data = await ajax.get('/authority/queryUserCollectedMenus', {userId: loginUser?.id});
    const menus = data
        .filter(item => item.type === 1)
        .map(item => ({...item, isCollectedMenu: true}));

    return formatMenus(menus);
}

/**
 * 保存用户收藏菜单
 * @param menuId
 * @param collected
 * @returns {Promise<void>}
 */
export async function saveCollectedMenu({menuId, collected}) {
    await ajax.post('/authority/addUserCollectMenu', {userId: getLoginUser()?.id, menuId, collected});
}

/**
 * 获取用户权限码
 * @returns {Promise<*[string]>}
 */
export async function getPermissions() {
    const serverMenus = await getMenuData();
    return serverMenus.filter(item => item.type === 2)
        .map(item => item.code);
}

/**
 * 获取子应用配置
 * @returns {Promise<*[{title, name, entry}]>}
 */
export async function getSubApps() {
    // 从菜单数据中获取需要注册的乾坤子项目
    const menuTreeData = await getMenus() || [];
    let result = [];
    const loop = nodes => nodes.forEach(node => {
        const {_target, children} = node;
        if (_target === 'qiankun') {
            const {title, name, entry} = node;
            result.push({
                title,
                name,
                entry,
            });
        }
        if (children?.length) loop(children);
    });
    loop(menuTreeData);

    return result;
}
